import React, { useMemo } from 'react';
import DashboardLayout from '../DashboardLayout/DashboardLayout';
import type { NavItem } from '../DashboardLayout/DashboardLayout';

// "Comunicazioni" è uno strumento per INVIARE notifiche agli utenti, non una
// casella di ricezione per l'admin: non esiste un "non letto" reale da
// mostrare qui, quindi niente badge finché non avrà un significato reale.
const AdminLayout: React.FC = () => {
  const navItems: NavItem[] = useMemo(
    () => [
      {
        path: '/admin',
        icon: 'bi-speedometer2',
        label: 'Panoramica',
        end: true,
      },
      { path: '/admin/utenti', icon: 'bi-people', label: 'Utenti' },
      { path: '/admin/corsi', icon: 'bi-collection-play', label: 'Corsi' },
      { path: '/admin/ordini', icon: 'bi-receipt', label: 'Ordini' },
      {
        path: '/admin/comunicazioni',
        icon: 'bi-megaphone',
        label: 'Comunicazioni',
        labelShort: 'Comms',
      },
    ],
    []
  );

  return (
    <DashboardLayout
      navItems={navItems}
      areaLabel="Area Admin"
      notifPath="/admin/comunicazioni"
    />
  );
};

export default AdminLayout;
